/** Duplicated from front/doctrine-ui-kit/scss/_global.scss */

export default {
  small: 0,
  medium: 769,
  large: 1002,
  xlarge: 1280,
  xxlarge: 1440,
};
